import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import ShopInfo from "@/components/ShopInfo"
import styles from "@/styles/article/return-policy.module.scss"
import Image from 'next/image'
import { UpOutlined } from '@ant-design/icons';

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

export default function ReturnPolicy() {
  // 回到顶部
  const backToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // 添加平滑滚动效果
    })
  }

  interface QuestionItem {
    question: string;
    answer: React.ReactNode;
  }

  const questionList = [
    {
      question: `Can I return an item if I've used it?`,
      answer: 
        <div className={styles['answer-desc']}>
          If you&apos;ve used an item and found it to be faulty, you can request a return. Our customer service will determine the problem with the product based on the information you provide. If it is a problem that is not caused by the customer, we will agree to your return request, otherwise, we will inform you of other processing options. You may have other rights such as a right of repair, replacement or refund. For more details please read Warranty Policy. Crazysales will not accept any return of any item without an RA from our Customer Service Representative.
        </div>
    },
    {
      question: 'Can I replace the item?',
      answer: 
        <div className={styles['answer-desc']}>
          If you&apos;ve used an item and found it to be faulty, you can request a return. Our customer service will determine the problem with the product based on the information you provide. If it is a problem that is not caused by the customer, we will agree to your return request, otherwise, we will inform you of other processing options. You may have other rights such as a right of repair, replacement or refund. For more details please read Warranty Policy. Crazysales will not accept any return of any item without an RA from our Customer Service Representative.
        </div>
    },
    {
      question: 'Who pays for return postage?',
      answer: 
        <div className={styles['answer-desc']}>
          When a return occurs, the return postage will be paid by the buyer unless the customer receives a damaged or faulty item. In other words, if it is a return of a problem item, the seller pays the shipping fee; if it is a return of a good item or a problem item caused by improper use, the buyer pays the shipping fee and testing fee.
        </div>
    },
    {
      question: 'How long do I have to send the item back? What if I miss the deadline?',
      answer: 
        <div className={styles['answer-desc']}>
          Notification is required within 30 days of the purchase date.<br></br>
          The product must be returned to us within 30 calendar days from the approved date.<br></br>
          Where the 30 Day Change-of-Mind period has elapsed and where Customer Service has determined that on the facts you have provided, a claim may be granted.<br></br>
        </div>
    },
    {
      question: 'When will I receive my refund?',
      answer: 
        <div className={styles['answer-desc']}>
          Your refund will be processed as soon as we receive your returned item and confirm that there is no problem. No refund or replacement will be given until we have received the product from you. Refunds will be issued via payment method (EFT, PayPal, Polipay, AfterPay, etc) or a credit to your account.
        </div>
    },
    {
      question: `Why did I receive a refund that's less than what I paid for the item?`,
      answer: 
        <div className={styles['answer-desc']}>
          If the item is dead on arrival or the product is found to be faulty during use, we will issue a full refund and cover your return shipping costs. Otherwise, we will deduct the corresponding fee following the terms & conditions of COM.
        </div>
    },
    {
      question: 'Can I return an item under warranty?',
      answer: 
        <div className={styles['answer-desc']}>
          We provide The CrazySales 30 Day Change-of-Mind(COM) return service.
          If the 30 Day Change-of-Mind period has elapsed and there is a problem with the product, it can also be returned after Customer Service has determined based on the facts you have provided. We will not accept the return of a product without approval from our Customer Service Team.
        </div>
    },
    {
      question: 'Can I change the delivery address after placing an order?',
      answer: 
        <div className={styles['answer-desc']}>
          If the item is not shipped, we will do our best to accommodate your needs, but if the item has shipped and left the warehouse, it can only meet your needs through the 30 Day Change-of-Mind process.
        </div>
    },
    {
      question: `Why haven't I received the item after a long time?`,
      answer: 
        <div className={styles['answer-desc']}>
          After the order is confirmed, we will ship it as soon as possible. However, in the event of big promotion festivals, there will be some delays in delivery speed and logistics. If there is no logistics information update within half a month after the product is shipped (one month during the promotion period), please contact our Customer Service Team by e-mail at info@crazysales.com.au to solve the problem.
        </div>
    },
    {
      question: 'Do you sell accessories?',
      answer: 
        <div className={styles['answer-desc']}>
          Accessories are generally not sold separately. You can consult us before the purchase. If we have the accessories, you can directly buy them from us. If not, it is recommended to buy directly from the locals.
        </div>
    }
  ]

  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout notStickyNavbar={true}>
        <div className={`${styles['page-return-policy']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <div className={styles["shop-info-box"]}>
            <ShopInfo hiddenContactus={true}></ShopInfo>
          </div>

          <div className={styles['content']}>
            <div className={styles['content-title']}>Return Policy</div>
            
            <div className={`${styles['ask-title']}`}>The CrazySales 30 Day Change-of-Mind Policy</div>
            <div className={styles['answer-desc']}>
              Online shopping sometimes means you don&apos;t get exactly what you had in mind. You are welcome to return the item as long as you meet the following terms and conditions as listed below:
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>Terms & Conditions</div>
            <div className={styles['answer-desc']}>
              • Notification is required within 30 days of the purchase date.<br></br>
              • Item to be returned must be in their original re-saleable condition with all tags and packaging (ready to be put back on the shelf).<br></br>
              • The items are NOT opened, used, worn or damaged.<br></br>
              • That you DO NOT stick or write anything on the item itself or its packaging. Please only write or place postage stickers on the outer postage packaging.<br></br>
              • Some items are not eligible for refund due to hygienic reasons.<br></br>
              • The refund amount will not include delivery costs. If the item was delivered for free, the delivery cost will be deducted.<br></br>
              • Handling fees will apply at 20% of the purchase price.<br></br>
              • The return of the item is the responsibility of the buyer.<br></br>
              • If the item has sustained damage in transit or does not return as noted above, a revised refund amount may be required.<br></br>
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>How It Works?</div>
            <div className={styles['answer-desc']}>
              If you would like to take this offer, please send us an email at info@crazysales.com.au and indicate the Order ID the items you wish to return and the reason for the return. Our Customer Service team will reply to your email and, if applicable, issue you a Return Authorization (RA) number. All other relevant information will be given to you at this time. Crazysales will not accept any return of any item without an RA from our Customer Service Representative.<br></br>
            </div>
            <Image
              className={styles['content-img']}
              src={`${imageDomain}/legal/return-policy-process.png`}
              alt={'return-policy-process'}
              width={1152}
              height={205}
            ></Image>
            <div className={`${styles['answer-desc']} padding-top-12`}>
              Where the 30 Day Change-of-Mind period has elapsed and where Customer Service has determined that on the facts you have provided, a claim may be granted. We will not accept the return of a product without approval from our Customer Service Team. The product must be returned to us within 30 calendar days from the approved date. Where possible, the product must be packed in the original, unmarked packaging including any accessories, manuals, documentation and registration that was delivered with the product.
            </div>
            <div className={`${styles['answer-desc']} padding-top-12`}>
              We will provide our Reply Paid number which can be used to return products sent by Australia Post eParcel. In the case of products sent by our other couriers, we will send you the contact details of our courier to organize pick up from your place.
            </div>
            <div className={`${styles['answer-desc']} padding-top-12`}>
              We reserve the right to test any returned product, and to ask you to demonstrate that the problem with the product was not your fault. After the product has been returned a final decision on granting the claim will be made by Customer Services.
            </div>

            <div className={`${styles['answer-desc']} padding-top-12`}>
              Where it is agreed that the claim is valid a replacement or repaired product will be returned to you at our expense.
            </div>
            <div className={`${styles['answer-desc']} padding-top-12`}>
              Once upon receipt of the returned product we determine that the product did comply with the warranties and conditions and the condition of the product was misrepresented to us by you, the expense for the return of the product to us and the expense of returning the product to you will be deducted from your account as well as a $30.00 handling and administration fee.
            </div>

            <div className={`${styles['ask-title']}`}>The CrazySales 30 Day PRE-ORDER price guarantee</div>
            <div className={styles['answer-desc']}>
              30 days pre-order price guarantee applies to all pre-order items on sales in m.crazysales.com.au; www.crazysales.com.au
            </div>
            <div className={styles['answer-desc']}>
              30 days refer to 30 calendar days after your order starts processing for delivery in our warehouse; 30 days period exclude the following special promotion: Flash sales, End of the financial year, Click Frenzy, Black Friday, Christmas promotion, and Boxing day promotion.
            </div>
            <div className={styles['answer-desc']}>
              Differences will be refunded in form of Crazy Points, please contact our customer service with your order details and evidence of lower price by e-mail to info@crazysales.com.au
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>Replacement</div>
            <div className={styles['answer-desc']}>
              Where a replacement is agreed to after a warranty claim is granted the replacement will be delivered to you at our expense after we have received your returned product. Where a non-warranty claim is granted the replacement will be delivered to you at your expense.
            </div>

            <div className={`${styles['content-title']} padding-top-30`}>Frequently Asked Questions</div>
            <div className={styles['questions-box']}>
              {
                questionList.map((item: QuestionItem, index: number) => (
                  <div key={`faq-${index}`}>
                    <div className={styles['title']} id={`faq${index}`}>
                      Q{index + 1}. {item.question}
                    </div>
                    <div className={styles['answer']}>{item.answer}</div>
                    <div className={styles['back-top']}>
                      <UpOutlined style={{ color: '#D70B17', marginRight: '4px' }} onClick={backToTop} />
                      <span onClick={backToTop}>Back to Top</span>
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}